import {
  GROUP_AB_TEST,
  GROUP_BASIC,
  GROUP_CONJOINT,
  GROUP_LOOP_MERGE,
  GROUP_MAXDIFF,
  GROUP_VAN_WESTENDORP,
} from 'data/nodeTypes';
import { isAbGroup, isConjointGroup, isMaxDiffGroup } from 'utils/nodeTypes';
import questionnaireMessages from 'containers/QuestionnairePage/messages';

import { getDisplayLabelWithGroupPrefix } from 'containers/QuestionnairePage/selectorUtils';
import { MAX_CONVERSATIONAL_AI_QUESTIONS } from 'containers/QuestionnairePage/GenericQuestion/ConversationalQuestion/constants';
import messages from './messages';
import { SETTINGS_TOOLTIP_TYPES } from './constants';

export function getLogicTitleMessage(isDisqualificationLogic, isDisplayLogic) {
  if (isDisqualificationLogic) {
    return messages.disqualificationLogic;
  }

  if (isDisplayLogic) {
    return messages.beforeRespondentAnswers;
  }

  return messages.whenRespondentAnswers;
}

export function getLogicTitleNodeLabel({ node, nodes }) {
  return getDisplayLabelWithGroupPrefix(node, nodes);
}

export function getToolTip(action, nodeType) {
  const tooltip = messages[action];
  const tooltipValues = {};

  switch (nodeType) {
    case GROUP_AB_TEST:
      tooltipValues.entityName = messages.abTest.defaultMessage;
      break;
    case GROUP_CONJOINT:
      tooltipValues.entityName = messages.conjoint.defaultMessage;
      break;
    case GROUP_MAXDIFF:
      tooltipValues.entityName = messages.maxDiff.defaultMessage;
      break;
    case GROUP_LOOP_MERGE:
    case GROUP_BASIC:
      tooltipValues.entityName = messages.group.defaultMessage;
      break;
    case GROUP_VAN_WESTENDORP:
      tooltipValues.entityName =
        questionnaireMessages.vanWestendorpLabelShort.defaultMessage;
      break;
    default:
      tooltipValues.entityName = messages.question.defaultMessage;
      break;
  }

  return {
    tooltip,
    tooltipValues,
  };
}

export function getDuplicateTooltip({
  canDuplicate,
  type,
  isConversationalAIQuestion,
  conversationalAILimitReached,
}) {
  let duplicateTooltip;

  if (canDuplicate) {
    duplicateTooltip = getToolTip(SETTINGS_TOOLTIP_TYPES.COPY, type);
  } else if (isAbGroup(type)) {
    duplicateTooltip = {
      tooltip: messages.duplicateDisabledDueToABTest,
    };
  } else if (isConjointGroup(type)) {
    duplicateTooltip = {
      tooltip: messages.duplicateDisabledDueToConjoint,
    };
  } else if (isMaxDiffGroup(type)) {
    duplicateTooltip = {
      tooltip: messages.duplicateDisabledDueToMaxDiff,
    };
  } else if (isConversationalAIQuestion && conversationalAILimitReached) {
    duplicateTooltip = {
      tooltip: messages.duplicateDisabledDueToConversationalAiLimitReached,
      tooltipValues: {
        limit: MAX_CONVERSATIONAL_AI_QUESTIONS,
      },
    };
  } else {
    duplicateTooltip = {
      showTooltipWhenDisabled: false,
    };
  }

  return duplicateTooltip;
}
